import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import { getConfig } from '@edx/frontend-platform';

import { isSpeechCraftMFE } from '../hooks/useIsSpeechcraftMFE';

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'few seconds ago',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1mnth',
    MM: '%dmnth',
    y: '1y',
    yy: '%dy',
  },
});

export const timeAgo = (date) => {
  const _date = dayjs(new Date(date));
  const currentDate = dayjs(new Date());
  const days = Math.round(currentDate.diff(_date, 'day', true));
  const weeks = Math.round(days / 7);

  if (days < 7) {
    return dayjs(new Date(date)).fromNow(true);
  }

  return `${weeks}w`;
};

export const getUserName = (userDetail = {}, fetchFirstNameOnly = false) => {
  const { firstName = '', lastName = '', name } = userDetail;

  if (!firstName && !lastName) {
    return name;
  }

  if (fetchFirstNameOnly) {
    return firstName;
  }

  return `${firstName} ${lastName}`;
};

export const getDashboardPlatformURL = () => {
  const isSpeechcraftMFE = isSpeechCraftMFE();

  return isSpeechcraftMFE
    ? `${getConfig().SPEECHCRAFT_MFE_BASE_URL}`
    : `${getConfig().LMS_BASE_URL}/dashboard`;
};

export const parseJwt = (token) => {
  if (!token) {
    return {};
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((val) => '%' + ('00' + val.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(jsonPayload);
};


export const safelyParseJSON = (json = '{}') => {
  // This function cannot be optimised, it's best to
  // keep it small!
  let parsed;

  try {
    parsed = JSON.parse(json);
  } catch (ex) {
    parsed = { detail: '' };
  }

  return parsed;
};

export const redirectBasedOnApiResponse = (error) => {
  const isSpeechcraftMFE = isSpeechCraftMFE();

  const errorMessage = safelyParseJSON(
    error?.customAttributes?.httpErrorResponseData
  ).detail;

  const BASE_URL = isSpeechcraftMFE
    ? getConfig().SPEECHCRAFT_MFE_BASE_URL
    : getConfig().DASHBOARD_MFE_BASE_URL;

  // handle 403
  // User's current event is expired or user has been removed from the event attendees
  // User can not access this platform. Check is_speech_craft and current_event in user TI profile if platform is Speechcraft else check is_pathways_enrolled if Pathways
  const errorMsgs = [
    "User's current event is expired or user has been removed from the event attendees",
    'User can not access this platform. Check is_speech_craft and current_event in user TI profile if platform is Speechcraft else check is_pathways_enrolled if Pathways',
  ];

  if (
    error?.customAttributes?.httpErrorStatus === 403 &&
    errorMsgs.includes(errorMessage)
  ) {
    window.location.replace(BASE_URL);
  }
};
